


























import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import MoreButton from '@/components/parts/catalog/list/item/components/More.vue';
import { ModuleBasketButton } from './components';
import { StateModuleMixin } from '@/services';
import { ListCardBadge } from '@/uikit';
import IsAuthorizedMixin from '@/mixins/isAuthorized';
import Modalform from '@/components/modalform/Modalform.vue';
import { blockByNewPdpConsent } from '@/tools/newPdpConsentGuard';

@Component({
  components: {
    Modalform,
    MoreButton,
    ListCardBadge,
    ModuleBasketButton,
  },

  inheritAttrs: false,
})
export default class ModuleCard extends Mixins(
  StateModuleMixin,
  IsAuthorizedMixin
) {
  @Prop({ type: Boolean, default: false })
  readonly isOvz!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly freeCost!: boolean;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly competences!: string;

  @Prop({ type: String, default: '' })
  readonly studentCategories!: string;

  @Prop({ type: String, default: '' })
  readonly formEducationId!: string;

  @Prop({ type: String, default: '' })
  readonly professionId!: string;

  @Prop({ type: String, default: '' })
  readonly cost!: string;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly weeks!: string;

  @Prop({ type: String, default: '' })
  readonly cop_multi_name!: string;

  isModuleAdded = false;
  deferredRequest = false;

  get badges() {
    const { isOvz, weeks } = this;
    const badges = [];
    if (isOvz) badges.push({ title: 'ОВЗ', mod: 'green' });
    if (weeks) badges.push({ title: weeks, mod: 'blue' });
    return badges;
  }

  @Watch('isAuthorized')
  checkAuthorized(value: boolean) {
    if (value && this.deferredRequest) {
      this.deferredRequest = false;
      this.$nextTick(() => this.addOrRemoveToBasket());
    }
  }

  get competencesList(): string {
    const {
      competences,
      $store: { state },
    } = this;

    if (!competences.length || !state.competences.length) return '';

    return state.competences.reduce(
      (res: string, { id, name }: { [key: string]: string }) => {
        if (competences.includes(id)) res += !res.length ? name : `, ${name}`;
        return res;
      },
      ''
    );
  }

  get educationForm(): string {
    const {
      formEducationId,
      $store: {
        state: { educationForm },
      },
    } = this;
    if (!formEducationId || !educationForm) return '';
    const result = educationForm.find(
      ({ id }: { id: number }) => id === parseInt(formEducationId, 10)
    );
    return result ? result.name : '';
  }

  get costParam(): string {
    const { freeCost, cost } = this;
    return freeCost ? 'Бесплатно' : cost ? `${cost} ₽` : 'Не указана цена';
  }

  get linkParam() {
    const { id } = this;
    return { name: 'module', params: { id } };
  }

  get moduleDataAddToBasket() {
    const {
      id,
      cost,
      title,
      weeks,
      competences,
      professionId,
      formEducationId,
      studentCategories,
    } = this;

    return {
      id,
      cost,
      title,
      weeks,
      competences,
      professionId,
      formEducationId,
      studentCategories,
    };
  }

  get isModuleSaved() {
    return !this.isAuthorized ? false : this.saved(this.moduleDataAddToBasket);
  }

  moreHandler() {
    const { linkParam } = this;
    this.$router.push(linkParam);
  }

  callBack(hash: string) {
    const { moduleDataAddToBasket, isModuleSaved } = this;

    const { isAuthorized } = this;
    if (isAuthorized) {
      this.toggle(moduleDataAddToBasket, isModuleSaved);
    } else {
      this.$store.state.nextOpenModuleCard = true;
      this.deferredRequest = true;
      this.$router.push({ hash: hash });
    }
  }
  addOrRemoveToBasket() {
    if (
      blockByNewPdpConsent(this.$store, this.addOrRemoveToBasket.bind(this))
    )
      return;
    const { moduleDataAddToBasket, isModuleSaved } = this;

    const { isAuthorized } = this;
    if (isAuthorized) {
      this.toggle(moduleDataAddToBasket, isModuleSaved);
    } else {
      this.$store.state.modalCallBack = this.callBack;
      this.$router.push({ hash: 'register_auth' });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/card/ModuleCard.vue